<template>
  <v-container class="my-16" fluid style="max-width: 960px">
    <v-row :class="userData.role === 'CALLC' ? 'mt-9' : null">
      <v-col>
        <v-card rounded="xl">
          <v-card-title class="px-9">
            <v-tooltip right color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="backButton"
                  large
                  color="primary"
                  fab
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="32" color="white">{{
                    icons.mdiArrowLeft
                  }}</v-icon>
                </v-btn>
              </template>
              <span>Geri Git</span>
            </v-tooltip>

            <span class="text-body-1 ml-4">
              <u> {{ data.refno }}</u> numaralı siparişi

              <v-chip class="ml-2" color="base" outlined>
                <v-icon left>{{ icons.mdiEye }}</v-icon>
                Görüntülüyorsunuz</v-chip
              >
            </span>
            <v-spacer />
            <Print :createdatetime="data.createdatetime" />
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col md="4">
                  <v-card height="120" outlined rounded="xl">
                    <v-card-text class="pb-1">
                      <v-icon left>
                        {{ icons.mdiBookmark }}
                      </v-icon>
                      <span class="text-caption">Sipariş Durum</span>
                    </v-card-text>
                    <v-card-text>
                      <div
                        :class="`${data.orderstatecolor}--text text-h6 font-weight-bold`"
                      >
                        {{ data.ordstatex }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col md="4">
                  <v-card height="120" outlined rounded="xl">
                    <v-card-text class="pb-1">
                      <v-icon left>
                        {{ icons.mdiWatermark }}
                      </v-icon>
                      <span class="text-caption">Şube</span>
                    </v-card-text>
                    <v-card-text>
                      <div :class="`text-h6 font-weight-bold`">
                        {{ data.officename }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col md="4">
                  <v-card height="120" outlined rounded="xl">
                    <v-card-text class="pb-1">
                      <v-icon left>
                        {{ icons.mdiFile }}
                      </v-icon>
                      <span class="text-caption">Sipariş Tutar</span>
                    </v-card-text>
                    <v-card-text>
                      <div class="text-caption mt-1">
                        Ürün :
                        <b class="white--text"
                          >{{ callCenterStore.totalProducts }} Adet</b
                        >
                        | Paket :
                        <b class="white--text"
                          >{{ callCenterStore.packageProducts }} Adet</b
                        >
                      </div>
                      <div :class="`secondary--text text-h6 font-weight-bold`">
                        {{ callCenterStore.sumProductsPrice | currency }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <OrderSummary />
            </v-container>
          </v-card-text>

          <CustomerSummary />
          <DeliverySummary />
          <InvoiceSummary v-if="callCenterStore.isInvoiceShow" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { useCallCenterStore } from "@/stores/callCenter";
import { useRouter } from "@core/utils";

// Components
import CustomerSummary from "./Customer.vue";
import DeliverySummary from "./Delivery.vue";
import InvoiceSummary from "./Invoice.vue";
import OrderSummary from "./Order.vue";
import Print from "./Print.vue";

// Icon
import {
  mdiArrowLeft,
  mdiEye,
  mdiBookmark,
  mdiFile,
  mdiWatermark,
} from "@mdi/js";

export default {
  components: {
    CustomerSummary,
    DeliverySummary,
    InvoiceSummary,
    OrderSummary,
    Print,
  },
  setup() {
    const callCenterStore = useCallCenterStore();
    const { route, router } = useRouter();
    const userData = JSON.parse(localStorage.getItem("userData"));

    const data = ref({});
    const viewData = (item) => {
      data.value = item;

      // Customer
      callCenterStore.data.customer.name = item.name;
      callCenterStore.data.customer.surname = item.surname;
      callCenterStore.data.customer.tel = item.tel;
      callCenterStore.data.customer.email = item.email;

      // Delivery
      callCenterStore.data.delivery.deliverydate = item.deliverydate;
      callCenterStore.data.delivery.deliveryhour = item.deliveryhour;
      callCenterStore.data.delivery.paymenttype = item.paymenttype;
      callCenterStore.data.delivery.customer = item.customer;
      callCenterStore.data.delivery.officename = item.officename;
      callCenterStore.data.delivery.city = item.city;
      callCenterStore.data.delivery.state = item.state;
      callCenterStore.data.delivery.address = item.address;
      callCenterStore.data.delivery.notes = item.notes;
      callCenterStore.data.delivery.needinvoice = item.needinvoice;
      callCenterStore.data.delivery.isdifferentinvoiceaddr =
        item.isdifferentinvoiceaddr;

      // Invoice
      if (callCenterStore.data.delivery.isdifferentinvoiceaddr) {
        callCenterStore.data.invoice.invaddrname = item.invaddrname;
        callCenterStore.data.invoice.invaddrsurname = item.invaddrsurname;
        callCenterStore.data.invoice.invaddrcompname = item.invaddrcompname;
        callCenterStore.data.invoice.invaddrvatno = item.invaddrvatno;
        callCenterStore.data.invoice.invaddrtaxtdept = item.invaddrtaxtdept;
        callCenterStore.data.invoice.invaddreinvtype = item.invaddreinvtype;
        callCenterStore.data.invoice.invaddrtel = item.invaddrtel;
        callCenterStore.data.invoice.invaddremail = item.invaddremail;
        callCenterStore.data.invoice.invaddrcity = item.invaddrcity;
        callCenterStore.data.invoice.invaddrstate = item.invaddrstate;
        callCenterStore.data.invoice.invaddr = item.invaddr;
        callCenterStore.isInvoiceShow = true;
      }

      // Order
      callCenterStore.data.products = item.lines.map((el) => {
        return {
          id: el.id,
          urun_kodu: el.refno,
          baslik: el.productname,
          altBaslik: el.subtitle,
          quantity: Number(el.qty),
          birim: el.currency,
          satis_fiyati: el.genprice,
        };
      });
    };

    const backButton = () => {
      if (userData.role === "CALLC") {
        router.push({ name: "dashboard-call-center" });
      } else {
        router.push({ name: "call-center-list" });
      }
    };
    onMounted(() => {
      if (route.value.params.item) {
        viewData(route.value.params.item);
      } else {
        if (userData.role === "CALLC") {
          router.push({ name: "dashboard-call-center" });
        } else {
          router.push({ name: "call-center-list" });
        }
      }
    });

    return {
      data,
      callCenterStore,
      backButton,
      userData,
      icons: {
        mdiArrowLeft,
        mdiBookmark,
        mdiFile,
        mdiWatermark,
        mdiEye,
      },
    };
  },
};
</script>

<style></style>
